import styled from 'styled-components';

const FilterStyle = styled.div`
	--filterTitleMarLeft: var(--sp3x);
	--filterTextIconDistance: var(--sp1x);

	--filterContentWrapperDistance: var(--sp5x);

	--filterContentWrapperBorderRadius: var(--sp4x);
	--filterContentWrapperPadTB: var(--sp6x);
	--filterContentWrapperPadLR: var(--sp6x);

	--filterFlexItemsGap: var(--sp7x);
	--optionsContainerWidth: calc(100% / 5 - ((var(--filterFlexItemsGap) * 4) / 5));
	--leftWrapperGap: var(--sp6x);
	--bottomBlockBtnGap: var(--sp3x);

	.filter-title-block {
		display: inline-flex;
		align-items: center;
		gap: var(--filterTextIconDistance);
		margin-left: var(--filterTitleMarLeft);
	}

	#collapse-item {
		.filter-arrow {
			transform: rotate(0);
			will-change: transform;
			transition: transform var(--trTime) ease-out;
		}

		&.active {
			.filter-arrow {
				transform: rotate(180deg);
			}
		}
	}

	#collapse-title {
		display: inline-flex;
	}

	.filter-content-wrapper {
		padding-top: var(--filterContentWrapperDistance);
	}

	.filter-content-inner-wrapper {
		border: 2px solid var(--green1000);
		border-radius: var(--filterContentWrapperBorderRadius);
		padding: var(--filterContentWrapperPadTB) var(--filterContentWrapperPadLR);
	}

	.left-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--leftWrapperGap);
	}

	.top-block {
		display: flex;
		gap: var(--filterFlexItemsGap);
	}

	.bottom-block {
		display: flex;
		align-items: center;
		gap: var(--bottomBlockBtnGap);
	}

	.options-container {
		width: var(--optionsContainerWidth);
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--filterTitleMarLeft: var(--sp2-5x);
		--filterTextIconDistance: var(--sp1x);

		--filterContentWrapperDistance: var(--sp4x);

		--filterContentWrapperBorderRadius: var(--sp3x);
		--filterContentWrapperPadTB: var(--sp5x);
		--filterContentWrapperPadLR: var(--sp5x);

		--filterFlexItemsGap: var(--sp5x);
		--leftWrapperGap: var(--sp6x);
		--bottomBlockBtnGap: var(--sp2x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--filterTitleMarLeft: var(--sp2x);
		--filterTextIconDistance: var(--sp1x);

		--filterContentWrapperDistance: var(--sp3x);

		--filterContentWrapperBorderRadius: var(--sp2-5x);
		--filterContentWrapperPadTB: var(--sp4x);
		--filterContentWrapperPadLR: var(--sp4x);

		--filterFlexItemsGap: var(--sp2x);
		--leftWrapperGap: var(--sp5x);
		--bottomBlockBtnGap: var(--sp3x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--filterTitleMarLeft: var(--sp1-5x);
		--filterTextIconDistance: var(--sp1x);

		--filterContentWrapperDistance: var(--sp2-5x);

		--filterContentWrapperBorderRadius: var(--sp2x);
		--filterContentWrapperPadTB: var(--sp4x);
		--filterContentWrapperPadLR: var(--sp4x);

		--filterFlexItemsGap: var(--sp2-5x);
		--leftWrapperGap: var(--sp5x);
		--bottomBlockBtnGap: var(--sp2x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--filterTitleMarLeft: var(--sp1-5x);
		--filterTextIconDistance: var(--sp1x);

		--filterContentWrapperDistance: var(--sp4x);

		--filterContentWrapperBorderRadius: var(--sp2x);
		--filterContentWrapperPadTB: var(--sp3x);
		--filterContentWrapperPadLR: var(--sp3x);

		--filterFlexItemsGap: var(--sp2x);
		--leftWrapperGap: var(--sp4x);
		--bottomBlockBtnGap: var(--sp2x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--filterTitleMarLeft: var(--sp2x);
		--filterTextIconDistance: var(--sp1x);

		--filterContentWrapperDistance: var(--sp3x);

		--filterContentWrapperBorderRadius: var(--sp2x);
		--filterContentWrapperPadTB: var(--sp3x);
		--filterContentWrapperPadLR: var(--sp3x);

		--filterFlexItemsGap: var(--sp1x);
		--leftWrapperGap: var(--sp3x);
		--bottomBlockBtnGap: var(--sp2x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--filterTitleMarLeft: var(--sp2x);
		--filterTextIconDistance: var(--sp1x);

		--filterContentWrapperDistance: var(--sp2x);

		--filterContentWrapperBorderRadius: var(--sp1-5x);
		--filterContentWrapperPadTB: var(--sp3x);
		--filterContentWrapperPadLR: var(--sp3x);

		--filterFlexItemsGap: var(--sp1x);
		--leftWrapperGap: var(--sp3x);
		--bottomBlockBtnGap: var(--sp2x);
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--filterTitleMarLeft: var(--sp1-5x);
		--filterTextIconDistance: var(--sp0-5x);

		--filterContentWrapperDistance: unset;

		--filterContentWrapperBorderRadius: unset;
		--filterContentWrapperPadTB: unset;
		--filterContentWrapperPadLR: unset;

		--filterFlexItemsGap: var(--sp1x);
		/* --optionsContainerWidth: calc(100% / 2 - ((var(--filterFlexItemsGap) * 1) / 2)); */
		--optionsContainerWidth: 100%;
		--leftWrapperGap: var(--sp4x);
		--bottomBlockBtnGap: var(--sp2x);

		.filter-title-block {
			cursor: pointer;
		}

		.top-block {
			flex-wrap: wrap;
			row-gap: var(--sp4x);
			flex: 1;
		}

		.filter-content-wrapper {
			position: fixed;
			bottom: 0;
			left: 0;
			z-index: 111;
			width: 100vw;
			height: calc(100dvh - var(--headerFixedHeight));
			padding: var(--sp3-5x) var(--sp2x) var(--sp2x);
			background-color: var(--lightGray1000);
			transform: translate3d(100%, 0, 0);
			will-change: transform;
			transition: transform 0.4s ease-out;

			&.active {
				transform: translate3d(0, 0, 0);
			}
		}

		.filter-content-flex-wrapper {
			height: 100%;
		}

		.filter-content-inner-wrapper {
			border: unset;
			height: 100%;
		}

		.left-wrapper {
			height: 100%;
		}

		.bottom-block {
			.btn {
				width: calc(100% - var(--bottomBlockBtnGap) / 2);

				a,
				button {
					width: 100%;
				}
			}
		}

		.filter-mobile-title-block {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: var(--bottomBlockBtnGap);
		}

		.top-block {
			overflow: hidden auto;
		}

		.options-title {
			font-size: var(--h4);
		}

		.option-label {
			font-size: var(--h5);
		}

		/* .filter-mobile-close-block {
			min-width: var(--sp3x);
			height: var(--sp3x);
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;

			background-color: blue;
		} */
	}
`;

export default FilterStyle;
